/**
 * Created by Andriyanto.
 * E-Mail Address: 4lenour@gmail.com
 * Date: 24/10/2024
 */
import {appHelper} from "../../../utils/helpers/appHelper.js";
import auth from "../../../middleware/auth.js";
import shortcuts from "../../../middleware/shortcuts.js";
import {routeHelper} from "../../../utils/helpers/routeHelper.js";


export const HrAppDefaults = [
    {
        path: appHelper.path.hrApp,
        name:'hrApp',
        component: routeHelper.asyncComponentWithLoader(() => import('../views/dashboard/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    },
    {
        name: 'hrAppSetting',
        path: appHelper.path.hrApp + '/setting',
        component: routeHelper.asyncComponentWithLoader(() => import('../../admin/views/settings/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    }
]
